import { useState } from 'react';

export default function useHelperText({ name, formIndex, defaultHelperText, useBusEffectOn }) {
  // validate defaultHelperText, can be invalid type
  const [helperText, setHelperText] = useState(defaultHelperText ?? { message: '', error: false });

  useBusEffectOn(`${formIndex}:${name}-set-helperText`, value => {
    function setter(pre) {
      // put logic here para ver qie tipo de helpertext se pone, si error pues error, si no error, pues
      // se pone el por defecto, si warning pues el the warning
    }

    setHelperText(setter);
  });

  useBusEffectOn(`${formIndex}:${name}-validation-result`, error => {
    function setter(pre) {
      // put logic here para ver qie tipo de helpertext se pone, si error pues error, si no error, pues
      // se pone el por defecto, si warning pues el the warning
      return { ...pre, ...error };
    }

    setHelperText(setter);
  });

  return {
    helperText,
    setHelperText,
  };
}
